import {
  GET_ROLE_PERMISSIONS,
  GET_ROLE_PERMISSIONS_FAIL,
  GET_ROLE_PERMISSIONS_SUCCESS,
  ADD_NEW_ROLE_PERMISSION,
  ADD_ROLE_PERMISSION_SUCCESS,
  ADD_ROLE_PERMISSION_FAIL,
  UPDATE_ROLE_PERMISSION,
  UPDATE_ROLE_PERMISSION_SUCCESS,
  UPDATE_ROLE_PERMISSION_FAIL,
  DELETE_ROLE_PERMISSION,
  DELETE_ROLE_PERMISSION_SUCCESS,
  DELETE_ROLE_PERMISSION_FAIL,
  
} from "./actionTypes";

export const getRolePermissions = () => ({
  type: GET_ROLE_PERMISSIONS,
})

export const getRolePermissionsSuccess = ROLE_PERMISSIONS => ({
  type: GET_ROLE_PERMISSIONS_SUCCESS,
  payload: ROLE_PERMISSIONS,
})

export const getRolePermissionsFail = error => ({
  type: GET_ROLE_PERMISSIONS_FAIL,
  payload: error,
})

export const addNewRolePermission = data => ({
  type: ADD_NEW_ROLE_PERMISSION,
  payload: data,
})

export const addRolePermissionSuccess = ROLE_PERMISSION => ({
  type: ADD_ROLE_PERMISSION_SUCCESS,
  payload: ROLE_PERMISSION,
})

export const addRolePermissionFail = error => ({
  type: ADD_ROLE_PERMISSION_FAIL,
  payload: error,
})

export const updateRolePermission = ROLE_PERMISSION => ({
  type: UPDATE_ROLE_PERMISSION,
  payload: ROLE_PERMISSION,
})

export const updateRolePermissionSuccess = ROLE_PERMISSION => ({
  type: UPDATE_ROLE_PERMISSION_SUCCESS,
  payload: ROLE_PERMISSION,
})

export const updateRolePermissionFail = error => ({
  type: UPDATE_ROLE_PERMISSION_FAIL,
  payload: error,
})

export const deleteRolePermission = data => ({
  type: DELETE_ROLE_PERMISSION,
  payload: data,
})

export const deleteRolePermissionSuccess = data => ({
  type: DELETE_ROLE_PERMISSION_SUCCESS,
  payload: data,
})

export const deleteRolePermissionFail = error => ({
  type: DELETE_ROLE_PERMISSION_FAIL,
  payload: error,
})

